// @ts-nocheck
document.querySelectorAll('[data-section-custom-blog]').forEach((section) => {
  const swiperEl = section.querySelector('.section-custom-blog__swiper');
  if (!swiperEl || typeof Swiper === 'undefined') return;

  new Swiper(swiperEl, {
    slidesPerView: 1.5,
    spaceBetween: 16,
    navigation: {
      prevEl: section.querySelector('.section-custom-blog__nav--prev'),
      nextEl: section.querySelector('.section-custom-blog__nav--next'),
    },
    pagination: {
      el: swiperEl.querySelector('.section-custom-blog__pagination'),
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    breakpoints: {
      750: { slidesPerView: 2, spaceBetween: 20 },
      990: { slidesPerView: 3, spaceBetween: 24 },
    },
  });
});
